<nb-accordion class="mb-4">
  <nb-accordion-item [expanded]="true">
    <nb-accordion-item-header>
      <div class="d-flex align-items-center">
        <i class="far fa-chart-line ms-2"></i>
        <span>گزارش‌گیری</span>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class="row mb-3">
        <div class="col-12 col-lg-12">
          <nb-card>
            <nb-card-header>فقط کاربران لیست</nb-card-header>
            <nb-card-body>
              <app-user-picker
                (add)="includedUsers = $event"
                (remove)="includedUsers = $event"
                [cacheKey]="'transaction_included_users'"
              ></app-user-picker>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3">
        <button nbButton status="primary" (click)="getDepositList({ first: 0, rows: limit })">
          گزارش‌گیری
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<nb-card>
  <nb-card-header>لیست برداشت‌های ریالی</nb-card-header>
  <nb-card-body>
    <nb-tabset (changeTab)="withdrawTypeChanged($event)">

      <nb-tab tabId="PENDING" tabTitle="در انتظار بررسی">
        <ng-container [ngTemplateOutlet]="GroupStatusChange"></ng-container>
        <ng-container
          *ngIf="withdrawStatus === 'PENDING'"
          [ngTemplateOutlet]="WithdrawRequestTemplate"
          [ngTemplateOutletContext]="{ withdrawType: withdrawStatus }"
        ></ng-container>
      </nb-tab>
      <nb-tab tabId="CHECKED_BY_OPERATOR" tabTitle="بررسی گردید">
        <ng-container [ngTemplateOutlet]="GroupStatusChange"></ng-container>
        <ng-container
          *ngIf="withdrawStatus === 'CHECKED_BY_OPERATOR'"
          [ngTemplateOutlet]="WithdrawRequestTemplate"
          [ngTemplateOutletContext]="{ withdrawType: withdrawStatus }"
        ></ng-container>
      </nb-tab>
      <nb-tab tabId="ERROR" tabTitle="خطا در برداشت">
        <ng-container
          *ngIf="withdrawStatus === 'ERROR'"
          [ngTemplateOutlet]="WithdrawRequestTemplate"
          [ngTemplateOutletContext]="{ withdrawType: withdrawStatus }"
        ></ng-container>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
<ng-template #WithdrawRequestTemplate let-withdrawType="withdrawType">
  <div class="d-none d-lg-flex align-items-center mb-2 gap-3">
    <nb-select
      class="ms-2"
      [selected]="50"
      (selectedChange)="changeRecordPerPageLimit($event)"
      placeholder="تعداد رکورد"
    >
      <nb-option [value]="10">10</nb-option>
      <nb-option [value]="15">15</nb-option>
      <nb-option [value]="25">25</nb-option>
      <nb-option [value]="50">50</nb-option>
      <nb-option [value]="100">100</nb-option>
    </nb-select>
    <button nbButton status="primary" (click)="selectAll()">انتخاب همه</button>
    <button nbButton status="warning" (click)="deSelectAll()">حذف همه</button>
  </div>

  <p-table
    [value]="pagination.data"
    [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
    [lazy]="true"
    (onLazyLoad)="getDepositList($event)"
    [alwaysShowPaginator]="false"
    [autoLayout]="true"
    [paginator]="true"
    [rows]="limit"
    [totalRecords]="pagination.totalRecords"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>انتخاب</th>
        <th>یادداشت</th>
        <th>شناسه</th>
        <th>کاربر</th>
        <th>نام بانک</th>
        <th>شماره شبا</th>
        <th>مقدار</th>
        <th>کارمزد</th>
        <th>درگاه</th>
        <th>نوع برداشت</th>
        <th>وضعیت</th>
        <th>شناسه پرداخت</th>
        <th>شناسه بانک</th>
        <th>تاریخ ایجاد</th>
        <th>ذخیره</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-withdraw>
      <tr>
        <td class="cursor-pointer">
          <nb-checkbox [(checked)]="withdraw.selectedWithdraw"></nb-checkbox>
        </td>
        <td class="cursor-pointer">
          <i (click)="openNote(withdraw.user.id)" class="fa fa-1x fa-sticky-note"></i>
        </td>
        <td>{{ withdraw.id }}</td>
        <td>
          <a
            class="text-primary"
            [routerLink]="withdraw.user?.id ? '/dashboard/user/' + withdraw.user?.id : null"
          >
            {{
              withdraw.user?.firstName || withdraw.user?.lastName
                ? withdraw.user.firstName + ' ' + withdraw.user.lastName
                : '-'
            }}
          </a>
        </td>
        <td>{{ withdraw.userIban | bankName : 'IBAN' | translateBankName }}</td>
        <td class="code">
          <i
            (click)="copy(withdraw.userIban, 'شماره شبا کپی شد.')"
            class="far fa-copy ms-1 cursor-pointer text-primary"
          ></i>
          {{ withdraw.userIban }}
        </td>
        <td>
          {{ withdraw.amount | number : '1.0-8' }}
        </td>
        <td>
          {{ withdraw.fee | number : '1.0-8' }}
        </td>
        <td>
          <nb-select
            fullWidth
            [status]="
              errors['status'] !== undefined && selectedWithdraw === withdraw ? 'danger' : 'basic'
            "
            [(selected)]="withdraw.provider"
          >
            <nb-option [value]="'JIBIT'">جیبیت</nb-option>
            <nb-option [value]="'VANDAR'">وندار</nb-option>
            <nb-option [value]="'ZIBAL'">زیبال</nb-option>
            <nb-option [value]="'NOVINPAL'">نوین‌پال</nb-option>
            <nb-option [value]="'PARSIAN'">بانک پارسیان</nb-option>
          </nb-select>
        </td>
        <td>
          <nb-select
            fullWidth
            [status]="
              errors['status'] !== undefined && transferMode === withdraw ? 'danger' : 'basic'
            "
            [(selected)]="withdraw.transferMode"
            placeholder="انتخاب نوع برداشت"
          >
            <nb-option *ngFor="let option of ['ACH', 'NORMAL']"
                       [value]="option">
              <ng-container *ngIf="option === 'NORMAL'">آنی</ng-container>
              <ng-container *ngIf="option === 'ACH'">شبا</ng-container>
            </nb-option>
          </nb-select>
        </td>
        <td>
          <nb-select
            fullWidth
            [status]="
              errors['status'] !== undefined && selectedWithdraw === withdraw ? 'danger' : 'basic'
            "
            [(selected)]="withdraw.status"
          >
            <nb-option
              *ngIf="withdrawType === 'PENDING' || 'CHECKED_BY_OPERATOR'"
              [value]="'PENDING'"
            >
              در حال بررسی
            </nb-option>
            <nb-option
              *ngIf="withdrawType === 'CHECKED_BY_OPERATOR' || 'PENDING'"
              [value]="'CHECKED_BY_OPERATOR'"
            >
              بررسی گردید
            </nb-option>
            <nb-option *ngIf="withdrawType === 'ERROR'" [value]="'ERROR'">خطا</nb-option>
            <nb-option [value]="'SUCCESSFUL'">انجام شده</nb-option>
            <nb-option [value]="'FAILED'">لغو شده</nb-option>
          </nb-select>
        </td>
        <td *ngIf="withdraw.callbackTrackingCode; else empty" class="code">
          {{ withdraw.callbackTrackingCode }}
        </td>
        <td *ngIf="withdraw.bankTransferId; else empty" class="code">
          {{ withdraw.bankTransferId }}
        </td>
        <ng-template #empty>
          <td>-</td>
        </ng-template>
        <td>
          {{ withdraw.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
        </td>
        <td>
          <button
            (click)="changeStatus(withdraw)"
            [nbSpinner]="saveLoading && selectedWithdraw === withdraw"
            [disabled]="
              withdraw.status === 'PENDING' ||
              withdraw.status === 'ERROR' ||
              saveLoading ||

              withdraw.transferMode === undefined
            "
            nbButton
            size="small"
            status="primary"
          >
            ذخیره
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
<ng-template #GroupStatusChange>
  <nb-card>
    <nb-card-header>تغییر وضعیت گروهی</nb-card-header>
    <nb-card-body>

      <div class="row align-items-end">
        <div class="col-12 col-lg-3">
          <label class="mb-2">درگاه</label>
          <nb-select
            fullWidth
            status="basic"
            [(selected)]="batchProvider"
          >
            <nb-option [value]="'JIBIT'">جیبیت</nb-option>
            <nb-option [value]="'VANDAR'">وندار</nb-option>
            <nb-option [value]="'ZIBAL'">زیبال</nb-option>
            <nb-option [value]="'PARSIAN'">بانک پارسیان</nb-option>
          </nb-select>
        </div>
        <div class="col-12 col-lg-3">
          <label class="mb-2">نوع برداشت</label>
          <nb-select
            fullWidth
            status="basic"
            [(selected)]="batchTransferMode"
            placeholder="انتخاب نوع برداشت"
          >
            <nb-option *ngFor="let option of ['ACH', 'NORMAL']"
                       [value]="option">
              <ng-container *ngIf="option === 'NORMAL'">آنی</ng-container>
              <ng-container *ngIf="option === 'ACH'">شبا</ng-container>
            </nb-option>
          </nb-select>
        </div>
        <div class="col-12 col-lg-3">
          <label class="mb-2">وضعیت</label>
          <nb-select
            fullWidth
            status="basic"
            [(selected)]="batchStatus"
          >
            <nb-option
              [value]="'PENDING'"
            >
              در حال بررسی
            </nb-option>
            <nb-option
              [value]="'CHECKED_BY_OPERATOR'"
            >
              بررسی گردید
            </nb-option>
            <nb-option [value]="'SUCCESSFUL'">انجام شده</nb-option>
            <nb-option [value]="'FAILED'">لغو شده</nb-option>
          </nb-select>
        </div>
        <div class="col-12 col-lg-3">
          <button
            (click)="changeBatchStatus()"
            [nbSpinner]="saveBatchLoading"
            nbButton
            status="primary"
          >
            ذخیره
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
